import { MODAL_TYPES } from 'config';
import InformationModal from './InformationModal';
import SuccessModal from './SuccessModal';
import NewOperationModal from './NewOperationModal';
import BulkAddModal from './BulkAddModal';
import ExportFileModal from './ExportFileModal';
import ExportLinksModal from './ExportLinksModal';
import ConfirmationModal from './ConfirmationModal';
import ViewClientModal from './ViewClientModal';

const allModals = {
  [MODAL_TYPES.infoModal]: InformationModal,
  [MODAL_TYPES.successModal]: SuccessModal,
  [MODAL_TYPES.formModal]: NewOperationModal,
  [MODAL_TYPES.bulkAddModal]: BulkAddModal,
  [MODAL_TYPES.exportFileModal]: ExportFileModal,
  [MODAL_TYPES.exportLinksModal]: ExportLinksModal,
  [MODAL_TYPES.confirmationModal]: ConfirmationModal,
  [MODAL_TYPES.viewClientModal]: ViewClientModal,
};

export default allModals;
